<div class="modal fade" *ngIf="webApi.isLoggedIn()" id="new-message-modal" tabindex="-1" aria-labelledby="disclaimerModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content modal-popup pt-4">
        <div class="content-section">
            <div *ngIf="user && webApi.newMessage" class="mb-4" [innerHTML]="webApi.newMessage.title"></div>
            <img *ngIf="webApi.newMessage && webApi.newMessage.image" style="max-width:100%;width:100%;" src={{getThumbUrl(webApi.newMessage.image)}}/> 
            <div class="d-flex justify-content-end mt-3">
                <button type="submit" data-bs-dismiss="modal" aria-label="Close" class="btn btn-gold mt-2 ml-auto">Close</button>
            </div>
          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
        </div>
      </div>
    </div>
  </div>